module.exports = __webpack_public_path__ + "static/media/access.a6b1db45.svg";